import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Grid, Tabs } from '~/components/blocks';
import { LineVisitorTabMap } from '~/constants/tab';
import { LineVisitorAppointmentDetailFragment } from '~/graphql/generated/graphql';
import { usePlanFeature } from '~/hooks/use-plan-feature';
import { lineVisitorTabState } from '~/state/reception/atoms';
import { LineVisitorTabType } from '~/state/reception/types';

import { FilePane } from './FilePane';
import { HistoryPane } from './HistoryPane';
import { MessagePane } from './MessagePane';
import { ReceptionPane } from './ReceptionPane';

type Props = {
  appointment: LineVisitorAppointmentDetailFragment;
};

export const LineVisitorKarte = React.memo((props: Props) => {
  const { appointment } = props;
  const { hasEnabledFeature: hasEnabledFollowup } = usePlanFeature('followup');
  const [tab, setTab] = useAtom(lineVisitorTabState);

  const handleChange = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      const element = e.target as HTMLButtonElement;
      const newTab = element.dataset['tab'] as LineVisitorTabType;

      setTab((_state) => ({ ..._state, type: newTab }));
    },
    [setTab],
  );

  return hasEnabledFollowup ? (
    <Grid height="100%" gridTemplateRows="min-content 1fr" gridAutoColumns="1fr">
      <Tabs>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.reception}
          data-tab={LineVisitorTabMap.reception}
          onClick={handleChange}
          size="xs"
        >
          受付
        </Tabs.Tab>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.history}
          data-tab={LineVisitorTabMap.history}
          onClick={handleChange}
          size="xs"
        >
          履歴
        </Tabs.Tab>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.message}
          data-tab={LineVisitorTabMap.message}
          onClick={handleChange}
          size="xs"
        >
          メッセージ
        </Tabs.Tab>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.file}
          data-tab={LineVisitorTabMap.file}
          onClick={handleChange}
          size="xs"
        >
          ファイル
        </Tabs.Tab>
      </Tabs>
      {tab.type === LineVisitorTabMap.reception && <ReceptionPane appointment={appointment} />}
      {tab.type === LineVisitorTabMap.history && (
        <HistoryPane lineVisitorId={appointment.lineVisitor?.id ?? ''} />
      )}
      {tab.type === LineVisitorTabMap.message && (
        <MessagePane lineVisitorId={appointment.lineVisitor?.id as string} />
      )}
      {tab.type === LineVisitorTabMap.file && (
        <FilePane lineVisitorId={appointment.lineVisitor?.id as string} />
      )}
    </Grid>
  ) : (
    <Grid height="100%" gridTemplateRows="min-content 1fr" gridAutoColumns="1fr">
      <Tabs>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.reception}
          data-tab={LineVisitorTabMap.reception}
          onClick={handleChange}
          size="xs"
        >
          受付
        </Tabs.Tab>
        <Tabs.Tab
          attached
          active={tab.type === LineVisitorTabMap.history}
          data-tab={LineVisitorTabMap.history}
          onClick={handleChange}
          size="xs"
        >
          履歴
        </Tabs.Tab>
      </Tabs>
      {tab.type === LineVisitorTabMap.reception && <ReceptionPane appointment={appointment} />}
      {tab.type === LineVisitorTabMap.history && (
        <HistoryPane lineVisitorId={appointment.lineVisitor?.id ?? ''} />
      )}
    </Grid>
  );
});

LineVisitorKarte.displayName = 'LineVisitorKarte';
